import { webPreferences, webSessionStorage } from './web';

import { runtime } from "../runtime";

// Load native code only in the app; never fall back to plaintext on failure.
const native = runtime.isNative() ? import("./native") : null;
const nativeStorage = Object.fromEntries(["get", "set", "remove", "clearAuth", "saveSession", "refreshSession", "acceptActivity", "renewAfterUnlock", "lock", "retryRevocations"].map(method =>
    [method, async (...args) => (await native).nativeSessionStorage[method](...args)]));
const selected = native ? nativeStorage : webSessionStorage;
export const authStorage = selected;
export const sessionStore = selected;
export const preferences = webPreferences;
export const storage = selected;

export default authStorage;
